export interface WindowWithZendesk extends Window {
  zE?: (action: string, command: string, ...params: any[]) => void;
  initZendesk?: () => void;
}

export enum ZenDeskActions {
  Messenger = 'messenger',
  Set = 'messenger:set',
}

export enum ZenDeskCommands {
  Open = 'open',
  Close = 'close',
  Cookies = 'cookies',
  Locale = 'locale',
  LoginUser = 'loginUser',
}

export interface ZendeskJwt {
  external_id: string;
  email: string;
  email_verified: boolean;
  scope: string;
  iat: number;
  exp: number;
}
